/**
 * Processes head HTML for preview mode by removing existing robots meta tags
 * and adding a noindex robots meta tag to prevent search engine indexing.
 *
 * @param {string} headHtml - The original head HTML string
 * @param {boolean} isPreview - Whether the page is in preview mode
 * @returns {string} The processed head HTML string
 */
export function processHeadForPreview(headHtml, isPreview) {
    if (!isPreview || !headHtml) {
        return headHtml;
    }

    // Remove existing robots meta tags (case insensitive)
    const cleanedHead = headHtml.replace(
        /<meta[^>]*name=["']robots["'][^>]*>/gi,
        ''
    );

    // Add noindex robots meta tag
    return cleanedHead + '<meta name="robots" content="noindex" />';
}
